import i18n from 'services/base/i18n';

export default {
  // Default pangolin nickname
  defaultName: () => 'Your Pangolin',

  title: (nickname: string) => i18n.sprintf(
    /* Title text on the page telling them they're finished setting up the Pangolin.
    %s is where the name they provided gets inserted. */
    i18n.pgettext('Pages|Add Pangolin|Success', '%s successfully activated!'),
    nickname,
  ),

  // A line telling them the benefits they get from setting up the Pangolin
  instructions: () => i18n.pgettext('Pages|Add Pangolin|Success', 'Enjoy a threat-free connection.'),

  // Text on a button the user clicks on after they're done with all the steps
  next: () => i18n.pgettext('Pages|Add Pangolin|Success', 'AWESOME'),
};
